import { IS_IBG_MANAGER } from "@/consts";
import type { EditorModel } from "@/types";
import Quill from "quill";
import { stripHtml } from "string-strip-html";

export default (html: string, force: boolean = false): EditorModel => {
  if (IS_IBG_MANAGER && !force) {
    return stripHtml(html)?.result || "";
  }

  const quill = new Quill(document.createElement("div"));
  return quill.clipboard.convert({ html });
};
